import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import { canAccessAppBench, canAccessPhysicalAi, canAccessScheduling } from '@/lib/product-flags';

/**
 * Keeps the legacy data-collection UI unavailable when a tenant only has the
 * independently licensed Red Team product. API middleware remains the
 * authoritative security boundary; this guard provides matching client UX.
 */
export function DataCollectionRoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary-600" />
      </div>
    );
  }

  if (user?.products?.data_collection === false) {
    const fallback = user.products.red_team
      ? '/admin/red-team/campaigns'
      : canAccessAppBench(user)
        ? '/admin/appbench'
        : canAccessPhysicalAi(user)
          ? '/admin/physical-ai'
          : canAccessScheduling(user)
            ? '/scheduling'
            : '/';
    return <Navigate to={fallback} replace />;
  }

  return <Outlet />;
}
